export default "__VITE_ASSET__CSsmxbfQ__"